var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0144 100C22.4446 100 0.0151367 77.5706 0.0151367 50.0007C0.0151367 22.4308 22.4446 0 50.0144 0C77.5843 0 100.015 22.4294 100.015 49.9993C100.015 77.5692 77.5843 100 50.0144 100ZM50.0144 4.77417C25.0768 4.77417 4.78931 25.0616 4.78931 49.9993C4.78931 74.937 25.0768 95.2244 50.0144 95.2244C74.9521 95.2244 95.2396 74.937 95.2396 49.9993C95.2396 25.0616 74.9521 4.77417 50.0144 4.77417Z",
    fill: "#21282C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3185 74.6724L19.5742 53.9281L27.0377 46.4646L40.3185 59.7454L73.8644 26.1995L81.3279 33.6629L40.3185 74.6724Z",
    fill: "#21282C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.0151367)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBlack);
export default __webpack_public_path__ + "static/media/checkBlack.61d0a74cb8dff9f1effad417b299188a.svg";
export { ForwardRef as ReactComponent };